<style lang="scss" scope>
.ivu-mt,
.ivu-mt-16 {
  margin-top: 16px !important;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.flex {
  display: flex !important;
  width: 100%;
}

.flex-warp {
  flex-wrap: wrap;
}

.mr1 {
  margin-right: 1rem;
  word-wrap: +break-word;
  word-break: +norm;
}

.flexs {
  display: flex !important;
  width: 15%;
}
</style>

<template>
  <el-card shadow="never" class="l-main-card">
    <div class="l-table-toolbar">

      <div class="flex flex-warp">
        <div class="flexs items-center ivu-mt ivu-mr">
          <l-auth-button type="primary" auth="Additional_add_btn" @click="add_visible = true"> 添加 </l-auth-button>
          <!-- <l-auth-button type="default" style="padding: 20px;" @click="clearSearch"> 重置
          </l-auth-button> -->
          <l-upload method="adminUserAdditional_uploadfile" accept=".xls,.xlsx" name="file" :show-file-list="false"
            :on-success="(res) => handleUploadSuccess(res, 'file')">
            <l-auth-button style="padding: 20px;" :loading="export_loading" type="primary" auth="batchReject"> 批量导入
            </l-auth-button>
          </l-upload>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">用户Id：</p>
          <el-input placeholder="请输入用户Id" v-model="search_data.app_user_id" class="input-with-select"
            style="width: 100%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">员工名：</p>
          <el-input placeholder="请输入员工名" v-model="search_data.admin_name" class="input-with-select"
            style="width: 100%;">
            <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
          </el-input>
        </div>

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属公司：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.corp_id" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in corp_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属部门：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.depart_id" placeholder="全部" clearable @change="changes">
              <el-option v-for="item in depart_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>

        <!-- <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">所属APP：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.app_type" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in app_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div> -->

        <div class="flexs items-center ivu-mt ivu-mr">
          <p class="mr1">状态：</p>
          <div class="l-show-more-search">
            <el-select v-model="search_data.state" placeholder="全部" clearable @change="changes" style="width: 100%;">
              <el-option v-for="item in state" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flexs items-center ivu-mt ivu-mr">
          <l-auth-button style="padding: 20px;" :loading="export_loading" type="primary" auth="batchAgree"
            @click="batchAgree(1)"> 批量通过 </l-auth-button>

          <l-auth-button style="padding: 20px;" :loading="export_loading" type="primary" auth="batchReject_xiufu_btn"
            @click="batchAgree(3)"> 批量通过漏掉用户
          </l-auth-button>
          <l-auth-button :loading="export_loading" type="primary" auth="batchReject" @click="batchAgree(2)"> 批量拒接
          </l-auth-button>
        </div>

      </div>
    </div>
    <l-table :data="data" v-loading="loading" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column fixed prop="index" label="序号" width="80"> </el-table-column>

      <el-table-column prop="user_name" label="员工名" min-width="130" show-overflow-tooltip> </el-table-column>
      <!-- <el-table-column prop="app_user_id" label="用户ID" min-width="200" show-overflow-tooltip> </el-table-column> -->
      <el-table-column prop="DisplayId" label="用户显示ID" min-width="130" show-overflow-tooltip> </el-table-column>
      <!-- 
                  <el-table-column prop="picture" label="上传截图" min-width="260" show-overflow-tooltip> 
                    <template slot-scope="{ row }">
                      <my-img-component :images="row.picture" :width="60" :height="60"></my-img-component>
                    </template>
</el-table-column> -->
      <el-table-column prop="state" label="状态" min-width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag type="primary" size="small" disable-transitions v-if="row.state == 0">{{ ADDITI_STATE[row.state]
            }}</el-tag>
          <el-tag type="success" size="small" disable-transitions v-if="row.state == 1">{{ ADDITI_STATE[row.state]
            }}</el-tag>
          <el-tag type="danger" size="small" disable-transitions v-if="row.state == 2">{{ ADDITI_STATE[row.state]
            }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="类型" min-width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-tag type="success" size="small" disable-transitions v-if="row.type == 1">手动添加</el-tag>
          <el-tag type="success" size="small" disable-transitions v-if="row.type == 2">批量添加</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="picture" label="上传截图" min-width="300" show-overflow-tooltip>
        <div class="demo-image__preview" slot-scope="{ row }">
          <el-image style="width: 100px; height: 150px; padding: 2px;" v-for="(item, idx) in row.picture" :key="idx"
            :src="item" :preview-src-list="row.picture">
          </el-image>
          <!-- <el-image style="width: 100px; height: 150px; padding: 1px;" :src="url" :preview-src-list="srcList">
              </el-image> -->
        </div>
      </el-table-column>
      <el-table-column prop="created_at" label="补录提交时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="app_id" label="归属平台" min-width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ APP_TYPE[row.app_id] }}
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="补录备注" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="cause" label="驳回理由" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="update_name" label="审核人" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="app_user_time" label="用户注册时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="admin_time" label="员工注册时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="add_time" label="添加好友时间" min-width="200" show-overflow-tooltip> </el-table-column>
      <el-table-column fixed="right" label="操作" min-width="200" align="center">
        <template slot-scope="{ row }">
          <l-auth-text-button type="primary" auth="pass_through_btn" @click="showInfn(row.id)" v-if="row.state == 0"><i
              class="el-icon-edit"></i>通过</l-auth-text-button>
          <span class="l-action-separator">|</span>
          <l-auth-text-button type="danger" auth="reject_btn" @click="showInfnS(row.id)" v-if="row.state == 0"><i
              class="el-icon-edit"></i>拒绝</l-auth-text-button>

          <l-auth-text-button type="primary" auth="rebind_btn" @click="rebind(row.id)" v-if="row.state != 0"><i
              class="el-icon-edit"></i>重新绑定</l-auth-text-button>
        </template>
      </el-table-column>
    </l-table>

    <!--分页-->
    <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size"
      :current-page.sync="page"></l-page>

    <!--详情-->
    <!-- <l-dialog :visible.sync="info_visible" title="详情" width="1200px">
                                  <l-logs-info :visible.sync="info_visible" :row="info_row" />
                                </l-dialog> -->
    <!--添加-->
    <l-dialog :visible.sync="add_visible" title="添加补录">
      <l-user-additional-edit @on-success="onAddSucess" :visible.sync="add_visible"
        :id="list_id"></l-user-additional-edit>
    </l-dialog>

    <l-dialog :visible.sync="info_visible" title="通过">
      <l-user-additional-info @on-success="onInfoSucess" :visible.sync="info_visible" :id="list_id"
        :cz_state="cz_state"></l-user-additional-info>
    </l-dialog>

    <l-dialog :visible.sync="rebind_visible" title="重新绑定">
      <l-user-additional-rebind @on-success="onInfoSucess" :visible.sync="rebind_visible" :id="list_id"
        :cz_state="cz_state"></l-user-additional-rebind>
    </l-dialog>

    <l-dialog :visible.sync="info_s_visible" title="拒接">
      <l-user-additional-info @on-success="onInfoSucess" :visible.sync="info_visible" :id="list_id"
        :cz_state="cz_state"></l-user-additional-info>
    </l-dialog>
    <l-dialog :visible.sync="info_enter_visible" title="确认信息">
      <div style="width:550px;height:100px;border:1px solid;margin:20px;display:flex;flex-direction: row;
    flex-wrap: nowrap;
    line-height:50px">
        <div style="width:200px;text-align:center">文件名称<div style="border-top:1px solid">{{ infoList.file_name }}</div>
        </div>
        <div style="width:200px;text-align:center">上传时间<div style="border-top:1px solid">{{ infoList.add_time }}</div>
        </div>
        <div style="width:200px;text-align:center">上传成功数量<div style="border-top:1px solid">{{ infoList.nums }}</div>
        </div>
      </div>
      <!-- <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>

    </div> -->
    </l-dialog>
  </el-card>
</template>

<script>
import Edit from "./Edit";
import Info from "./Info";
import Vue from "vue";
import Rebind from "./Rebind.vue"
import { APP_TYPE, ADDITI_STATE } from "../appUser/state";
export default {
  components: {
    [Edit.name]: Edit,
    [Info.name]: Info,
    [Rebind.name]: Rebind,
  },
  data() {
    return {
      list_id: 0,
      cz_state: "",
      box: 1,
      data: [],
      infoList: {},
      count: 0,
      page: 1,
      page_size: Vue.$_config.page.page_size,
      export_loading: false,
      loading: false,
      info_visible: false, //是否显示编辑
      info_s_visible: false,
      rebind_visible: false,
      info_enter_visible: false,
      info_row: 0,
      APP_TYPE: APP_TYPE,
      ADDITI_STATE: ADDITI_STATE,
      add_visible: false, //是否显示添加
      state: [
        {
          "id": 0,
          "name": "待审核"
        },
        {
          "id": 1,
          "name": "通过"
        },
        {
          "id": 2,
          "name": "拒绝"
        },
      ],
      //搜索
      search_visible: false,
      site_list: [],
      search_data: {
        app_user_id: "",
        admin_name: "",
        app_type: "",
        state: "",
        corp_id: "",
        depart_id: ""
      },
      rel_search_data: {},
      show_more_search: false,
      app_list: [
        {
          "id": 1,
          "name": "星伴"
        }
      ],
      accountRecordId: [],
      corp_list: [],
      depart_list: [],
    };
  },

  mounted() {
    this.getList();
    this.getSearchData();
  },

  methods: {
    getSearchData() {
      // this.loading = true;
      this.$_invoke("adminUser_getSearchData", {
        corp_id: this.search_data.corp_id,
        depart_id: this.search_data.depart_id,
      })
        .then((ret) => {
          console.log(ret)
          this.corp_list = ret.corp_list;
          this.depart_list = ret.depart_list;
        })
        .finally(() => {
          // this.loading = false;
        });

    },
    handleUploadSuccess(res, file) {
      this.info_enter_visible = true;
      console.log('res:' + res, 'res.data：' + res.data, 'file:' + file);

      this.infoList = res.data;

      this.getList();


    },
    changes() {
      this.getList();
      this.getSearchData();
    },
    rebind(id) {
      this.cz_state = 3;
      this.list_id = id;
      this.$nextTick(() => {
        this.rebind_visible = true;
      });
    },

    handleSelectionChange(val) {
      val.map((item) => {
        //  this.accountRecordId 为自己定义的值
        this.accountRecordId.push(item.id)

      });
      console.log(this.accountRecordId);
    },
    batchAgree(key) {
      console.log(this.search_data.state)
      // if(this.search_data.state  == ""){
      //   this.$_msg.error('请选择状态！');
      //   return;
      // }
      if (this.search_data.state != "0") {
        this.$_msg.error('状态必须待审核！');
        return;
      }
      var is_state = ""
      // console.log('2222');
      if (key === 3) {
        is_state = "xiufu"
        key = 1
      }

      if (this.accountRecordId.length == 0) {
        this.$_msg.error('请选择操作对象！');
      } else {
        this.$confirm(
          "确定批量操作吗" + "？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.export_loading = true;
            this.$_invoke(`adminUserAdditional_update`, { id_arr: this.accountRecordId, key: key, cz_state: key, is_state: is_state }).then((ret) => {
              console.log(ret);
              this.$_msg.success("操作成功");
              this.getList();
              this.export_loading = false;
              this.accountRecordId = [];
            });
          })
          .catch(() => { });
      }

    },
    //获取数据
    getList() {
      this.loading = true;
      this.$_invoke("adminUserAdditional_getList", {
        page: this.page,
        page_size: this.page_size,
        ...this.search_data,
      })
        .then((ret) => {
          console.log(ret.data);
          this.data = ret.data;
          this.count = ret.count;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },

    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },

    showInfn(id) {
      this.cz_state = 1;
      this.list_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },


    showInfnS(id) {
      this.cz_state = 2;
      this.list_id = id;
      this.$nextTick(() => {
        this.info_s_visible = true;
      });
    },



    //操作
    showEdit(id) {
      this.list_id = id;
      this.$nextTick(() => {
        this.add_visible = true;
      });
    },

    // 和修改  添加成功回调
    onAddSucess() {
      this.add_visible = false;
      this.getList();
    },

    onInfoSucess() {
      this.info_visible = false;
      this.info_s_visible = false;
      this.getList();
    },

    //清除搜索数据
    clearSearch() {
      this.search_data.app_user_id = "";
      this.search_data.admin_name = "";
      this.search_data.app_type = "";
      this.search_data.corp_id = "";
      this.search_data.depart_id = "";
      this.getList();
    },
  },
};
</script>
